"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const text_1 = require("../text");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const CustomText_1 = __importDefault(require("../text/CustomText"));
const Hashtags = (props) => {
    const { hashtags, defaultLine, gap = (0, scale_1.scale)(8), lineHeight = (0, scale_1.scale)(21), containerStyle = {}, textStyle = {}, type, } = props;
    const [showMoreButtonVisible, setShowMoreButtonVisible] = (0, react_1.useState)(false);
    const [isFolded, setFolded] = (0, react_1.useState)(true);
    const HASHTAG_LINE_HEIGHT = lineHeight + gap;
    const onLayout = (event) => {
        const contentLine = ~~(event.nativeEvent.layout.height / HASHTAG_LINE_HEIGHT);
        if (contentLine > defaultLine) {
            setShowMoreButtonVisible(true);
        }
    };
    return (react_1.default.createElement(react_native_1.View, { style: [{ position: 'relative' }, containerStyle] },
        react_1.default.createElement(react_native_1.View, { style: [
                styles.hashTagList,
                { gap },
                isFolded && { maxHeight: HASHTAG_LINE_HEIGHT * defaultLine },
            ] }, hashtags.map((item, index) => (react_1.default.createElement(text_1.HashtagText, { key: index, text: item.name, style: [styles.hashTag, textStyle, { lineHeight }], onPress: () => {
                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                    screen: Routes_1.default.HASHTAG_DETAIL,
                    params: {
                        hashtag: item.name,
                        typeScreen: 0,
                        typeHashTag: type ? 1 : 2
                    },
                });
            } })))),
        showMoreButtonVisible && (react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.hashTagMoreButton, onPress: () => {
                setFolded(false);
                setShowMoreButtonVisible(false);
            } },
            react_1.default.createElement(CustomText_1.default, { style: styles.hashTagMoreLabel }, "\u3055\u3089\u306B\u8868\u793A"))),
        isFolded && (react_1.default.createElement(react_native_1.View, { style: styles.invisibleView },
            react_1.default.createElement(react_native_1.View, { style: [styles.hashTagList, { gap }], onLayout: onLayout }, hashtags.map((item, index) => (react_1.default.createElement(text_1.HashtagText, { key: index, text: item.name, style: [styles.hashTag, textStyle, { lineHeight }] }))))))));
};
exports.default = Hashtags;
const styles = react_native_1.StyleSheet.create({
    hashTagList: {
        width: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
        zIndex: 1,
        overflow: 'hidden'
    },
    hashTag: {
        fontSize: (0, scale_1.moderateScale)(14),
        color: '#007AFF'
    },
    hashTagMoreButton: {
        alignSelf: 'flex-start',
        zIndex: 1
    },
    hashTagMoreLabel: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#007AFF'
    },
    invisibleView: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 0,
        opacity: 0,
    },
});
